/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListContractReviewersResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'ContractReviewer',
        },
        isRequired: true,
      },
    },
  }],
} as const;
